// extracted by mini-css-extract-plugin
export default {"tick":"CloneQuoteOption_tick__JaqPr","text":"CloneQuoteOption_text__MekA-"};